import { useNavigate } from "react-router-dom";
import { Box, Button, Tooltip } from "@mui/material";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div>
      {/* <Button onClick={() =>navigate("/") }><img src="/Batuk-logo.png" alt="" /> </Button> */}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Tooltip title="Go to Home Page" >
          <Button onClick={() => navigate("/")}>
            <img src="/Notfound.jpg" alt="" width="630px" />{" "}
          </Button>
        </Tooltip>
        {/* <Button onClick={() => navigate("/")}>
        <img src="/Notfound.jpg" alt=""  width="630px"/>{" "}
      </Button> */}
      </Box>
    </div>
  );
}
